import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

import Login from '../auth/Login.vue';
import Register from '../auth/Register.vue';
import VerifyAccount from '../auth/VerifyAccount.vue';
import RecoverPassword from '../auth/RecoverPassword.vue';
import NewPassword from '../auth/NewPassword.vue';

import Dashboard from '../pages/Dashboard.vue';
import IssuedCfdis from "../pages/IssuedCfdis.vue"
import ReceivedCfdis from "../pages/ReceivedCfdis.vue"
import CfdisPorPagar from "../pages/CfdisPorPagar.vue"
import CfdisPorCobrar from "../pages/CfdisPorCobrar.vue"
import PaymentReconciliation from "../pages/PaymentReconciliation.vue"
import DiotWorkpaper from "../pages/DiotWorkpaper.vue"
import DownloadCenter from "../pages/DownloadCenter.vue"
import TaxesSummary from "../pages/TaxesSummary.vue"
import TuscfdisAiChat from "../pages/TuscfdisAiChat.vue"
import DownloadMonitoring from "../pages/DownloadMonitoring.vue"

import Validations from "../pages/Validations.vue"
import AdminAccounts from "../pages/AdminAccounts.vue"
import Settings from "../pages/Settings.vue"
import NotFound from '../pages/error/404.vue'
import accountService from '@/services/account';

const ACTIVITY_TOUCH_MIN_INTERVAL_MS = 60000;
let lastActivityTouchAt = 0;
let lastTouchedPath = '';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Iniciar Sesión - TusCFDIs',
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: 'Crear Cuenta - TusCFDIs',
    }
  },
  {
    path: '/verify-account',
    name: 'verifyAccount',
    component: VerifyAccount,
    meta: {
      title: 'Verificar Cuenta - TusCFDIs',
    }
  },
  {
    path: '/recover-password',
    name: 'recoverPassword',
    component: RecoverPassword,
    meta: {
      title: 'Recuperar Cuenta - TusCFDIs',
    }
  },
  {
    path: '/new-password',
    name: 'newPassword',
    component: NewPassword,
    meta: {
      title: 'Recuperar Cuenta - TusCFDIs',
    }
  },
  {
    path: '/',
    component: Body,
    children: [
      {
        path: '', 
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'Bienvenido - TusCFDIs.com',
        }
      },
      {
        path: 'emitidos',
        name: 'issuedCfdis',
        component: IssuedCfdis,
        meta: {
          title: 'CFDIs Enviados - TusCFDIs.com',
        }
      },
      {
        path: 'recibidos',
        name: 'receivedCfdis',
        component: ReceivedCfdis,
        meta: {
          title: 'CFDIs Recibidos - TusCFDIs.com',
        }
      },
      {
        path: 'cfdis-por-pagar',
        name: 'cfdisPorPagar',
        component: CfdisPorPagar,
        meta: {
          title: 'CFDIs por Pagar - TusCFDIs.com',
        }
      },
      {
        path: 'cfdis-por-cobrar',
        name: 'cfdisPorCobrar',
        component: CfdisPorCobrar,
        meta: {
          title: 'CFDIs por Cobrar - TusCFDIs.com',
        }
      },
      {
        path: 'conciliacion-pagos/emitidos',
        name: 'paymentReconciliationIssued',
        component: PaymentReconciliation,
        meta: {
          title: 'Conciliación de Pagos Emitidos - TusCFDIs.com',
          paymentReconciliationNature: 'issued',
        }
      },
      {
        path: 'conciliacion-pagos/recibidos',
        name: 'paymentReconciliationReceived',
        component: PaymentReconciliation,
        meta: {
          title: 'Conciliación de Pagos Recibidos - TusCFDIs.com',
          paymentReconciliationNature: 'received',
        }
      },
      {
        path: 'papel-trabajo-diot',
        name: 'diotWorkpaper',
        component: DiotWorkpaper,
        meta: {
          title: 'Papel de Trabajo DIOT - TusCFDIs.com',
        }
      },
      {
        path: 'centro-descargas',
        name: 'downloadCenter',
        component: DownloadCenter,
        meta: {
          title: 'Centro de Descargas - TusCFDIs.com',
        }
      },
      {
        path: 'tuscfdis-ia',
        name: 'tuscfdisIaChat',
        component: TuscfdisAiChat,
        meta: {
          title: 'TusCFDIs IA - TusCFDIs.com',
        }
      },
      {
        path: 'validaciones',
        name: 'validations',
        component: Validations,
        meta: {
          title: 'Validaciones - TusCFDIs.com',
        }
      },
      {
            path: 'impuestos',
            name: 'taxesSummary',
            component: TaxesSummary,
            meta: {
              title: 'Impuestos - TusCFDIs.com',
            }
          },
      {
        path: 'administracion',
        name: 'adminAccounts',
        component: AdminAccounts,
        meta: {
          title: 'Administración - TusCFDIs.com',
          requiresAdmin: true,
        }
      },
      {
        path: 'monitoreo-descargas',
        name: 'downloadMonitoring',
        component: DownloadMonitoring,
        meta: {
          title: 'Monitoreo de Descargas - TusCFDIs.com',
          requiresAdmin: true,
          allowedAdminEmails: ['raalveco@gmail.com'],
        }
      },
      {
        path: 'configuracion',
        name: 'settings',
        component: Settings,
        meta: {
          title: 'Configuración - TusCFDIs.com',
        }
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFound,
    meta: {
      title: 'Página no encontrada - TusCFDIs',
    }
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  const host = String(window.location.hostname || '').trim().toLowerCase();
  const appEnv = String(process.env.VUE_APP_ENV || '').trim().toLowerCase();
  const isDemoEnvironment = host === 'demo.tuscfdis.com' || appEnv === 'demo';

  if (isDemoEnvironment && ['register', 'recoverPassword', 'newPassword'].includes(String(to.name || ''))) {
    return next('/login');
  }

  const publicPaths = ['/login', '/register', '/verify-account', '/recover-password', '/new-password', '/changelog'];
  const token = localStorage.getItem('access_token');

  if (to.name === 'notFound' || publicPaths.includes(to.path) || token) {
    let currentUser = null;
    const rawUser = localStorage.getItem('user');
    if (rawUser && rawUser !== 'undefined') {
      try {
        currentUser = JSON.parse(rawUser) || null;
      } catch (error) {
        currentUser = null;
      }
    }

    if (to.meta?.requiresAdmin) {
      let isAdmin = false;

      isAdmin = Boolean(currentUser && currentUser.is_admin);

      if (!isAdmin) {
        return next('/');
      }
    }

    const allowedAdminEmails = Array.isArray(to.meta?.allowedAdminEmails)
      ? to.meta.allowedAdminEmails
      : [];

    if (allowedAdminEmails.length > 0) {
      const currentEmail = String(currentUser && currentUser.email ? currentUser.email : '').trim().toLowerCase();
      const isAllowed = allowedAdminEmails
        .map((email) => String(email || '').trim().toLowerCase())
        .includes(currentEmail);

      if (!isAllowed) {
        return next('/');
      }
    }

    return next();
  }
  next('/login');
});

router.afterEach(async (to) => {
  const publicPaths = ['/login', '/register', '/verify-account', '/recover-password', '/new-password', '/changelog'];
  const token = localStorage.getItem('access_token');

  if (!token || token === 'undefined') {
    return;
  }

  if (to.name === 'notFound' || publicPaths.includes(to.path)) {
    return;
  }

  const now = Date.now();
  const currentPath = String(to.fullPath || to.path || '');
  const isSamePath = currentPath !== '' && currentPath === lastTouchedPath;

  if (isSamePath && now - lastActivityTouchAt < ACTIVITY_TOUCH_MIN_INTERVAL_MS) {
    return;
  }

  if (!isSamePath && now - lastActivityTouchAt < 15000) {
    return;
  }

  lastTouchedPath = currentPath;
  lastActivityTouchAt = now;

  try {
    await accountService.activityTouch({
      route_name: to.name || null,
      route_path: currentPath,
    });
  } catch (error) {
    // Best effort: failing this telemetry-style update must not affect navigation.
  }
});

export default router